import { render, staticRenderFns } from "./orderpoolQueryDetail.vue?vue&type=template&id=bfc2c03e&scoped=true"
import script from "./orderpoolQueryDetail.vue?vue&type=script&lang=js"
export * from "./orderpoolQueryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc2c03e",
  null
  
)

export default component.exports